export default function FormTabs({ tabs, active, onChange }) {
  return (
    <div className="flex border-b border-gray-200" role="tablist">
      {tabs.map((tab) => {
        const selected = active === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => onChange(tab.id)}
            className={`flex-1 px-3 py-2.5 text-sm font-medium ${
              selected
                ? 'border-b-2 border-slate-900 text-slate-900'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}

export function FormTabPanel({ id, active, children }) {
  return (
    <div
      role="tabpanel"
      data-form-tab={id}
      hidden={active !== id}
      className="space-y-4"
    >
      {children}
    </div>
  );
}
